exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-width span {\r\n  width: 6em;\r\n}\r\n.editor-label {\r\n  font-size: 12px;\r\n  margin-left: 30px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/pages/lead-text/custom-toolbar-options/styles.css
// module id = 2311
// module chunks = 29